wizardSteps["packageDates"] = {
    templateName: "#m-modal__package-dates-template",
    onInit: function() {
        Handlebars.registerPartial("coursePackEditor", $("#m-modal__course-pack-editor-template").html());
        Handlebars.registerPartial("coursePackList", $("#m-modal__course-pack-list-template").html());
    },
    availablePros: [],
    beforeRender: function (ctx) {
        ctx.model.o.__isAnOccObject = true;

        if (currentEvent.title) {
            ctx.model.modalTitle = currentEvent.title;
        } else {
            ctx.model.modalTitle = $t("New course package");
        }

        if (currentEvent.price) {
            ctx.model.appPrice = currentEvent.price;
        } else {
            ctx.model.appPrice = currentEvent.price = calendarConfiguration.hourlyFee;
        }

        if (typeof (ctx.model.o.occurences) === "undefined") {
            ctx.model.o.occurences = [];
        }

        ctx.model.messages = {
            maximumParticipants: $t("Maximum participants")
        };

        if (!currentEvent.maxParticipants) {
            // Single trainings can only have one participant
            currentEvent.maxParticipants = currentEvent.appointmentType === "SingleTraining" ? 1 : 5;
        }

        ctx.model.canSetPrice = calendarConfiguration.loginUserType !== 'Me';
    },
    afterRender: function(ctx) {
        // #region times
        var $timeStart = $("#time-start");
        var $timeEnd = $("#time-end");

        var updateFunction = function() {
            // Disable options not belonging to the group of the currently selected start time.
            var $selectedOption = $timeStart.find('option:selected');
            var groupId = $selectedOption.attr('data-group');
            if (groupId) {
                $timeEnd.find('option[data-group="' + groupId + '"]').prop('disabled', false);
                $timeEnd.find('option:not([data-group="' + groupId + '"])').prop('disabled', true);
            }

            // Select the corresponding end time when the currently selected end time is no longer available.
            var $selectedEndTime = $timeEnd.find('option:selected');
            if ($selectedEndTime.is(':disabled')) {
                var idx = $timeStart.prop('selectedIndex');
                $timeEnd.prop('selectedIndex', idx);
            }
        };

        $timeStart.on("change", function () {
            // When changing the start time, we want to adjust the end accordingly
            updateFunction();
        });

        if (calendarConfiguration.loginUserType === 'Golf Academy') {

            var selectCurrentTime = function() {
                $timeStart.find("[value='" + currentEvent.start.format("HH:mm") + "']").attr("selected", true);
                if (currentEvent.end) {
                    $timeEnd.find("[value='" + currentEvent.end.format("HH:mm") + "']").attr("selected", true);
                } else {
                    var selectedStartIndex = $timeStart.find(":selected").data("index");
                    if (selectedStartIndex === -1) {
                        console.error("Could not update start time: Could not calculate current start time");
                    }
                    var size = $timeEnd.children().length;
                    var targetEndIndex = selectedStartIndex + 1;
                    if (targetEndIndex >= size) {
                        targetEndIndex = size;
                    }
                    $timeEnd.children().eq(targetEndIndex).prop('selected', true);
                }
            };

            ApiClient.loadAcademyProList(currentEvent.locationId).done(function(d) {
                var $proSelection = $('#m-modal__pro-selection');

                wizardSteps["packageDates"].availablePros = d.data.pros;

                if (currentEvent.appointmentType === 'SingleTraining' ||
                    currentEvent.appointmentType === 'Absence') {
                    $proSelection.parents('.m-modal__row').first().hide();
                    $proSelection.prop("disabled", true);
                } else if ($proSelection.length) {
                    $proSelection.parents('.m-modal__row').first().show();

                    var template = Handlebars.partials['academyProList'];
                    $proSelection.append(template({ proOptions: d.data.pros }));

                    if ($calendar.fullCalendar('getView').type === 'timelineDay' || calendarConfiguration.calendarType === "Courses") {
                        $proSelection.prop("disabled", false);
                    } else {
                        $proSelection.prop("disabled", true);
                    }

                    if (currentEvent.trainerId) { // academies
                        $proSelection.val(currentEvent.trainerId);
                    } else if (!currentEvent.id &&
                        currentEvent.trainerId &&
                        calendarConfiguration.calendarType !== 'Courses') {
                        $proSelection.prop("disabled", true)
                            .val(calendarConfiguration.calendarOwnerId);
                    } else if ($proSelection.find('option[value="'+calendarConfiguration.calendarOwnerId+'"]').length) {
                        $proSelection.val(calendarConfiguration.calendarOwnerId);
                    } else {
                        // Select no trainer
                        $proSelection.val("");
                    }
                }
            });
        }

        //#region Package Title
        var $titleField = $("#m-modal__input-appointment-title");

        var updateTitleFunction = function () {
            var title = $titleField.val();
            if (!title) {
                title = ctx.model.modalTitle = $t("New course package");
            }
            ctx.model.modalTitle = title;
            $("#m-modal__step--package-headline").text(title);
            currentEvent.title = ctx.model.modalTitle;
        };

        $titleField.on("change", updateTitleFunction);
        //#endregion

        //#region Package price
        var $priceField = $("#m-modal__price-panel");
        var updatePriceFunction = function () {
            var price = $priceField.val();
            if (!price) {
                price = ctx.model.appPrice = 0;
            }
            ctx.model.appPrice = price;
            currentEvent.price = ctx.model.appPrice;
        };

        $priceField.on("change", updatePriceFunction);
        //#endregion

        InitTimeSelection($timeStart, false);
        InitTimeSelection($timeEnd, true);
        updateFunction();
        // #endregion times

        //#region Occurrence creation
        var $dateSelection = $("#m-modal__course-pack-date-selection");
        $dateSelection.datepicker({
                dateFormat: dateTimeFormatString.dateFormatPicker
            }).val(currentEvent.start.format('L'));
        var $startTime = $("#time-start");
        $startTime.val(currentEvent.start.format("HH:mm"));
        var $endTime = $("#time-end");
        $endTime[0].selectedIndex = $startTime[0].selectedIndex + 1;
        var $description = $("#m-modal__textarea-appointment-description");

        var reRenderList = function () {
            var $appointmentList = $("#m-modal__course-pack-appointment-list");
            $appointmentList.html(Handlebars.partials["coursePackList"](ctx.model));

            // Bind remove buttons
            var $btns = $appointmentList.find(".m-modal__icon--appointment-remove");
            console.info("Bound event to " + $btns.length + " trash can buttons");
            $btns.click(function () {
                var $packEntry = $(this).parent(".m-modal__course-pack-list-entry");
                var index = $packEntry.data("packentryindex");
                $packEntry.remove();
                currentEvent.occurences.splice(index, 1);
                ctx.model.o.occurences = currentEvent.occurences;
                reRenderList();
                console.info("Removed entry " + index + " from pack list");
            });
        };

        if (currentEvent.occurences.length > 0) {
            reRenderList();
        }

        var cleanCoursePackEditor = function () {
            $description.val("");
            $startTime.val(currentEvent.start.format("HH:mm"));
            $endTime[0].selectedIndex = $startTime[0].selectedIndex + 1;
        };

        $("#m-modal__btn-add-course-pack-occurrence").click(function () {
            var date = moment($dateSelection.datepicker("getDate")).format("YYYY-MM-DD") + "T";
            var startDate = date + $startTime.val() + ":00";
            var endDate = date + $endTime.val() + ":00";

            var $validation = $(".m-modal__validation-error.coursePackTimes");
            if (startDate >= endDate) {
                $validation.show();
                return;
            }
            $validation.hide();

            currentEvent.occurences.push({
                startDate: startDate,
                endDate: endDate,
                description: $description.val()
            });

            reRenderList();
            cleanCoursePackEditor();
        });

        var $maxParticipantsField = $("#m-modal__input-participants-count");

        var updateMaxParticipantsFunction = function () {
            var maxParticipants = $maxParticipantsField.val();
            if (!maxParticipants) {
                maxParticipants = ctx.model.maxParticipants = 5;
            }
            ctx.model.maxParticipants = maxParticipants;
            currentEvent.maxParticipants = ctx.model.maxParticipants;
        };

        $maxParticipantsField.on("change", function () {
            updateMaxParticipantsFunction();
            wizardSteps["participants"].refreshParticipantWarning();
        });

        // Max participants input field

        $maxParticipantsField.on("change", function () {
            currentEvent.maxParticipants = parseInt($maxParticipantsField.val());
            if (isNaN(currentEvent.maxParticipants) || currentEvent.maxParticipants < 1) {
                currentEvent.maxParticipants = 1;
                maxParticipantsInputField.val(1);
            }
            wizardSteps["participants"].refreshParticipantWarning();
        });

        ctx.$el.find('.m-modal__appointment__button--text-template')
            .on('click',
                function () {
                    OpenModal('chooseTextTemplate');
                });
        //#endregion
    },
    validate: function() {
        // Hide previous errors.
        var $errorPanel = $('.m-modal__text.package-error');
        $errorPanel.hide();

        var $occurrences = $('#m-modal__course-pack-appointment-list .m-modal__course-pack-list-entry');
        $occurrences.removeClass('m-modal__error-border');

        // Fetch selected pro.
        var pros = wizardSteps["packageDates"].availablePros;
        var $proSelection = $('#m-modal__pro-selection');

        var id = $proSelection.val();

        var pro = pros.find(function (pro) {
            return pro.id === id;
        });

        // No pro no time validation.
        if (!pro) {
            return true;
        }

        var hasError = false;

        // Validate each single occurrence.
        for (var i = 0; i < currentEvent.occurences.length; i++) {
            var occ = currentEvent.occurences[i];

            var start = moment.utc(occ.startDate);
            var end = moment.utc(occ.endDate);

            if (!CheckForValidWorkingTimes(pro, start, end)) {
                hasError = true;
                $($occurrences.get(i)).addClass('m-modal__error-border');
            }
        }

        if (hasError) {
            $errorPanel.text($t('Mindestens einer der Termine ist außerhalb der Arbeitszeiten des gewählten Pros.'))
                .show();
        }

        return !hasError;
    },
    save: function () {

        currentEvent.title = $("#m-modal__input-coursepack-title").val();
        currentEvent.coursePackDescription = $("#m-modal__textarea-coursepack-description").val();
        currentEvent.trainerId = $('#m-modal__pro-selection').val() || null;

        var isPublic = $("input[name='isPublic']");
        currentEvent.isPublic = isPublic.is(':checked');
    },
    getButtonList: function () {
        return {
            "next": "participants",
            "back": true,
            "save": false
        };
    }
};
